export type CookieName =
	| "Language"
	| "Dobco.AcceptedAllCookies"
	| "Dobco.AcceptedNecessaryCookies"
	| "LocalImageCaches"
	| "shownNews"
	| "Source"
	| "SeriesPickerWidth"
	| "PreferredRecognitionLanguage";

export function setInCookie(name: CookieName, value: any, nDays: number) {
	const date = new Date();
	date.setDate(date.getDate() + nDays);

	document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
}

export function getFromCookie(name: CookieName): string | null {
	if (typeof document === "undefined" || typeof document.cookie === "undefined") {
		return null;
	}

	const value = "; " + document.cookie;
	const parts = value.split("; " + name + "=");

	if (parts != null && parts.length == 2) {
		return parts.pop()!.split(";").shift() ?? null;
	}

	return null;
}

export function getFromCookieAsNumber(name: CookieName): number | null {
	const cookieValueAsString = getFromCookie(name);
	if (!cookieValueAsString) return null;

	const cookieValueAsNumber = Number.parseInt(cookieValueAsString);
	if (isNaN(cookieValueAsNumber) || Number.isNaN(cookieValueAsNumber)) {
		return null;
	}

	return cookieValueAsNumber;
}

export function getFromCookieAsBoolean(name: CookieName): boolean | null {
	const cookieValueAsString = getFromCookie(name);
	if (!cookieValueAsString) return null;

	return cookieValueAsString.toLowerCase() === "true";
}
